export const MERGE_TYPES = {
  date: 'DATE',
  month: 'MONTH',
};

export const REPORT_KEYS = {
  expensesGraph: 'expensesGraph',
  incomeGraph: 'incomeGraph',
  insightsGraph: 'insightsGraph',
  bankTransactions: 'bankTransactions',
};

export const FILTER_TYPES = {
  monthToDate: 'monthToDate',
  lastMonth: 'lastMonth',
  lastThreeMonth: 'lastThreeMonth',
  yearToDate: 'yearToDate',
  dateRange: 'dateRange',
  monthRange: 'monthRange',
};
